import React from "react";

// Circular arrow shown between the outgoing (old) and incoming (new) pack cards.
// Exact Figma asset: 40px white circle + two-layer drop shadow, #E2E8F0 ring,
// #5358EE arrow. Filter/mask ids are per-instance (useId) so multiple instances
// on a page never collide.
//
// direction="down" rotates only the two arrow strokes about the circle's centre,
// for the compact layout that stacks OUTGOING above INCOMING. Deliberately a prop
// rather than a second component: the circle, ring and shadow-filter defs are the
// bulk of this asset and duplicating them to turn an arrow 90 degrees would mean
// two copies to keep in sync.
export default function CircleArrowRightIcon({ size = 46, direction = "right" }) {
    const uid = React.useId().replace(/:/g, "");
    const shadowId = `arrowShadow-${uid}`;
    const maskId = `arrowMask-${uid}`;

    return (
        <svg width={size} height={size} viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter={`url(#${shadowId})`}>
                <mask id={maskId} fill="white">
                    <path d="M3 22C3 10.9543 11.9543 2 23 2C34.0457 2 43 10.9543 43 22C43 33.0457 34.0457 42 23 42C11.9543 42 3 33.0457 3 22Z" />
                </mask>
                <path d="M3 22C3 10.9543 11.9543 2 23 2C34.0457 2 43 10.9543 43 22C43 33.0457 34.0457 42 23 42C11.9543 42 3 33.0457 3 22Z" fill="white" shapeRendering="crispEdges" />
                <path d="M23 42V41C12.5066 41 4 32.4934 4 22H3H2C2 33.598 11.402 43 23 43V42ZM43 22H42C42 32.4934 33.4934 41 23 41V42V43C34.598 43 44 33.598 44 22H43ZM23 2V3C33.4934 3 42 11.5066 42 22H43H44C44 10.402 34.598 1 23 1V2ZM23 2V1C11.402 1 2 10.402 2 22H3H4C4 11.5066 12.5066 3 23 3V2Z" fill="#E2E8F0" mask={`url(#${maskId})`} />
                <g transform={direction === "down" ? "rotate(90 23 22)" : undefined}>
                    <path d="M18.333 22H27.6663" stroke="#5358EE" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M23 17.334L27.6667 22.0007L23 26.6673" stroke="#5358EE" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                </g>
            </g>
            <defs>
                <filter id={shadowId} x="0" y="0" width="46" height="46" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="1.5" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.00784314 0 0 0 0 0.0235294 0 0 0 0 0.0941176 0 0 0 0.06 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="1" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.00784314 0 0 0 0 0.0235294 0 0 0 0 0.0941176 0 0 0 0.04 0" />
                    <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow" result="shape" />
                </filter>
            </defs>
        </svg>
    );
}
